class SearchStore {
  private _element: any = {};
  private _material: any = {};

  setElement(callback: any) {
    this._element = callback(this._element);
    console.log(this._element);
  }

  getElement() {
    return this._element;
  }

  setMaterial(callback: any) {
    this._material = callback(this._material);
  }

  getMaterial() {
    return this._material;
  }

  clearAll() {
    this._element = {};
    this._material = {};
  }
}

export default new SearchStore();
